/**
 * SearchEvents
 * Registry of events for the Global Search + Command Palette components
 */
export enum SearchEvents {
    CommandPaletteOpen = "Search - Command Palette - Open",
    CommandPaletteClose = "Search - Command Palette - Close",
    CommandPaletteSelectResult = "Search - Command Palette - Select Result",

    GlobalSearchOpen = "Search - Navbar - Open",
    GlobalSearchClose = "Search - Navbar - Close",
    GlobalSearchSelectResult = "Search - Navbar - Select Result",

    RecentSearchAdd = "Search - Recent - Add",
    RecentSearchClear = "Search - Recent - Clear",

    SearchQuery = "Search - Query",

    SearchPageSelectResult = "Search - Page - Select Result",
}
